import React, { useState } from 'react';
import AlphabetList from '../../components/AlphabetList/AlphabetList';
import CategoryNavigation from '../../components/CategoryNavigation/CategoryNavigation';
import CommonList from '../../components/CommonList/CommonList';
import { CategoryContainer } from '../../shared-styled/layout/CategoryContainer';
import CategoryTabs from '../../shared-styled/layout/CategoryTabs';
import StickyWrapper from '../../shared-styled/layout/StickyWrapper';
import getHistoricalAndActiveItems from '../../utils/getHistoricalAndActiveItems';
import BasePageWrap from '../BasePage';

const WeaponsCategoryPage = ({ items, parentItm }) => {
  const isRootSubCategory = parentItm.url.split('/').length < 4;
  const List = isRootSubCategory ? CommonList : AlphabetList;

  const [activeItems, historicalItems] = getHistoricalAndActiveItems(items);
  const [activeTab, setActiveTab] = useState(
    activeItems.length > 0 ? 'live' : 'historical',
  );

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const displayHistorical =
    activeTab === 'historical' && historicalItems.length > 0;
  const displayActive = activeTab === 'live' && activeItems.length > 0;

  return (
    <CategoryContainer>
      <StickyWrapper>
        <CategoryNavigation />
      </StickyWrapper>
      {!isRootSubCategory && (
        <CategoryTabs
          handleTabChange={handleTabChange}
          activeTab={activeTab}
          displayHistorical={historicalItems.length > 0}
          displayActive={activeItems.length > 0}
        />
      )}
      {displayHistorical && <List items={historicalItems} />}
      {displayActive && <List items={activeItems} />}
    </CategoryContainer>
  );
};

export default BasePageWrap(WeaponsCategoryPage);
